/* unplugin-vue-components disabled */import _objectSpread from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id"];
import tinymce from "tinymce/tinymce";
import $axios from "axios";
// import { getToken } from "@/utils/auth";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/themes/silver";
import "tinymce/icons/default/icons";
import "tinymce/plugins/advlist";
// import "tinymce/plugins/anchor";  // 锚点
import "tinymce/plugins/autolink";
import "tinymce/plugins/autosave";
import "tinymce/plugins/code";
// import "tinymce/plugins/codesample"; //编辑插入代码样本实例
import "tinymce/plugins/directionality";
// import "tinymce/plugins/fullscreen";  // 全屏
// import "tinymce/plugins/hr"; //水平分割线
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
// import "tinymce/plugins/media"; // 编辑、插入媒体
// import "tinymce/plugins/nonbreaking"; //插入、不间断空间
import "tinymce/plugins/noneditable";
// import "tinymce/plugins/pagebreak";  //分页符
import "tinymce/plugins/paste";
// import "tinymce/plugins/preview";  //预览
// import "tinymce/plugins/print";  //打印
import "tinymce/plugins/save";
// import "tinymce/plugins/searchreplace"; // 搜索和替换
// import "tinymce/plugins/spellchecker";  //拼写检查器
import "tinymce/plugins/tabfocus";
// import "tinymce/plugins/template";  //插入模板
// import "tinymce/plugins/textpattern";  // 文本模式
// import "tinymce/plugins/visualblocks"; // 可视化快
// import "tinymce/plugins/visualchars"; //可视字符
import "tinymce/plugins/wordcount";
import "tinymce/plugins/image"; // 插入编辑图片
// import 'tinymce/plugins/table';

// import { computed, nextTick, ref, unref, watch, onDeactivated, onBeforeUnmount, defineProps, defineEmits, getCurrentInstance } from "vue";
import { toolbar, plugins } from "./tinymce";
import { buildShortUUID, isNumber } from "@/util/tinymce.js";
import { bindHandlers } from "./helper";
import { onMountedOrActivated } from "@/util/onMountedOrActivated.js";
import { flieUpload } from "@/api/apis";
export default {
  __name: 'tinymce',
  props: {
    options: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String
    },
    is_ReadOnly: {
      type: Boolean
    },
    toolbar: {
      type: Array,
      default: toolbar
    },
    plugins: {
      type: Array,
      default: plugins
    },
    modelValue: {
      type: String
    },
    height: {
      type: [Number, String],
      required: false,
      default: 400
    },
    width: {
      type: [Number, String],
      required: false,
      default: "auto"
    },
    showImageUpload: {
      type: Boolean,
      default: true
    }
  },
  emits: ["change", "change1", "update:modelValue", "inited", "init-error"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    /** 一个页面调用多次，就多建立几个change事件绑定  */
    var emits = __emit;
    var {
      attrs
    } = getCurrentInstance();
    var tinymceId = ref(buildShortUUID("tiny-vue"));
    var containerWidth = computed(() => {
      var width = props.width;
      if (isNumber(width)) {
        return "".concat(width, "px");
      }
      return width;
    });
    var editorRef = ref(null);
    // const fullscreen = ref(false);
    var elRef = ref(null);
    var tinymceContent = computed(() => props.modelValue);
    var uploadUrl = ref("");
    var initOptions = computed(() => {
      var {
        height,
        options,
        toolbar,
        plugins
      } = props;
      var publicPath = "/";
      return _objectSpread(_objectSpread({
        selector: "#".concat(unref(tinymceId)),
        height,
        toolbar,
        menubar: "file edit insert view format table",
        plugins,
        media_live_embeds: true,
        // 支持嵌入视频（如 YouTube）
        media_alt_source: true,
        // 支持备用视频源
        media_poster: true,
        // 支持设置视频封面
        media_dimensions: true,
        // 显示视频尺寸设置
        paste_data_images: true,
        // 关键：允许粘贴图片（base64）
        paste_retain_style_properties: "all",
        // 保留粘贴样式
        paste_word_valid_elements: "*[*]",
        // 允许粘贴 Word 内容
        paste_enable_default_filters: false,
        // 关闭默认粘贴过滤paste_data_images: true, // 关键：允许粘贴图片（base64）
        paste_retain_style_properties: "all",
        // 保留粘贴样式
        paste_word_valid_elements: "*[*]",
        // 允许粘贴 Word 内容
        paste_enable_default_filters: false,
        // 关闭默认粘贴过
        language_url: "/resource/langs/zh_CN.js",
        language: "zh_CN",
        branding: false,
        default_link_target: "_blank",
        link_title: false,
        object_resizing: false,
        auto_focus: true,
        readonly: props.is_ReadOnly,
        skin: "oxide",
        skin_url: "/resource/skins/ui/oxide",
        content_css: "/resource/skins/ui/oxide/content.min.css",
        // 图片读取前缀路径
        // 图片本地上传方法  点击上传后执行的事件
        images_upload_handler: (blobInfo, success, failure) => {
          var isAccord = blobInfo.blob().type == "image/jpeg" || blobInfo.blob().type == "image/png" || blobInfo.blob().type == "image/GIF" || blobInfo.blob().type == "image/jpg" || blobInfo.blob().type == "image/BMP";
          if (isAccord) {
            if (blobInfo.blob().size / 1024 / 1024 > 5) {
              failure("上传失败，图片大小请控制在 5M 以内");
            } else {
              var formData = new FormData();
              formData.append("file", blobInfo.blob(), blobInfo.filename());
              formData.append("content_type", 1);
              flieUpload(formData).then(res => {
                success(res.data.file_url);
              }).catch(() => {
                failure("上传失败");
              });
            }
          } else {
            failure("图片格式错误");
          }
        },
        file_picker_callback: (callback, value, meta) => {
          var accept = "*/*";
          if (meta.filetype === "image") {
            accept = "image/*";
          }
          if (meta.filetype === "media") {
            accept = "video/*";
          }
          if (meta.filetype === "file") {
            accept = "*/*"; // 或限制类型如 '.pdf,.docx'
          }
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", accept);
          input.onchange = function () {
            var file = this.files[0];
            var formData = new FormData();
            formData.append("file", file);
            var contentType = 1; // 默认是图片
            if (meta.filetype === "media") contentType = 2; // 视频
            if (meta.filetype === "file") contentType = 5; // 文档

            formData.append("content_type", contentType);
            flieUpload(formData).then(res => {
              if (res.code === 200) {
                callback(res.data.file_url, {
                  text: file.name
                });
              } else {
                alert("上传失败：" + res.msg);
              }
            }).catch(() => {
              alert("请求失败，上传中断");
            });
          };
          input.click();
        }
      }, options), {}, {
        setup: editor => {
          editorRef.value = editor;
          editor.on("init", e => initSetup(e));
        }
      });
    });
    // 上传本地 图片执行事件
    function handleImgUpload(blobInfo, success, failure) {
      var formdata = new FormData();
      // append 方法中的第一个参数就是 我们要上传文件 在后台接收的文件名
      // 这个值要根据后台来定义
      // 第二个参数是我们上传的文件
      formdata.append("file", blobInfo.blob());
      // axios 定义上传方法
      $axios({
        method: "post",
        // post方法
        url: uploadUrl.value,
        // 请求上传图片服务器的路径
        // headers: {
        //   // 配置headers请求头
        //   Authorization: getToken(), // token认证，看后台
        //   "Content-Type": "application/x-www-form-urlencoded", // 采用表单上传的方式，看后台如何接受
        // },
        data: formdata // 请求数据formdata
      }).then(res => {
        if (res.data.code != 200) {
          // 上传失败执行此方法，将失败信息填入参数中
          failure("HTTP Error: " + res.msg);
          return;
        }
        // 上传成功之后，将对应完整的图片路径拼接在success的参数中
        success(res.data.url);
      });
    }
    var disabled = computed(() => {
      var {
        options
      } = props;
      var getdDisabled = options && Reflect.get(options, "readonly");
      var editor = unref(editorRef);
      if (editor) {
        editor.setMode(getdDisabled ? "readonly" : "design");
      }
      return getdDisabled !== null && getdDisabled !== void 0 ? getdDisabled : false;
    });
    watch(() => attrs.disabled, () => {
      var editor = unref(editorRef);
      if (!editor) {
        return;
      }
      editor.setMode(attrs.disabled ? "readonly" : "design");
    });
    onMountedOrActivated(() => {
      if (!initOptions.value.inline) {
        tinymceId.value = buildShortUUID("tiny-vue");
      }
      nextTick(() => {
        setTimeout(() => {
          initEditor();
        }, 30);
      });
    });
    onBeforeUnmount(() => {
      destory();
    });
    onDeactivated(() => {
      destory();
    });
    function destory() {
      if (tinymce !== null) {
        // tinymce?.remove?.(unref(initOptions).selector!);
      }
    }
    function initSetup(e) {
      var editor = unref(editorRef);
      if (!editor) {
        return;
      }
      var value = props.modelValue || "";
      editor.setContent(value);
      bindModelHandlers(editor);
      bindHandlers(e, attrs, unref(editorRef));
    }
    function initEditor() {
      var el = unref(elRef);
      if (el) {
        el.style.visibility = "";
      }
      tinymce.init(unref(initOptions)).then(editor => {
        emits("inited", editor);
      }).catch(err => {
        emits("init-error", err);
      });
    }
    function setValue(editor, val, prevVal) {
      if (editor && typeof val === "string" && val !== prevVal && val !== editor.getContent({
        format: attrs.outputFormat
      })) {
        editor.setContent(val);
      }
    }
    function bindModelHandlers(editor) {
      var modelEvents = attrs.modelEvents ? attrs.modelEvents : null;
      var normalizedEvents = Array.isArray(modelEvents) ? modelEvents.join(" ") : modelEvents;
      watch(() => props.modelValue, (val, prevVal) => {
        setValue(editor, val, prevVal);
      });
      watch(() => props.value, (val, prevVal) => {
        setValue(editor, val, prevVal);
      }, {
        immediate: true
      });
      /** 一个页面调用多次，就多建立几个change事件绑定  */
      editor.on(normalizedEvents || "change change1 keyup undo redo", () => {
        var content = editor.getContent({
          format: attrs.outputFormat
        });
        emits("update:modelValue", content);
        emits("change", content);
        emits("change1", content);
      });
      editor.on("FullscreenStateChanged", e => {
        fullscreen.value = e.state;
      });
    }
    function handleImageUploading(name) {
      var _editor$getContent;
      var editor = unref(editorRef);
      if (!editor) {
        return;
      }
      editor.execCommand("mceInsertContent", false, getUploadingImgName(name));
      var content = (_editor$getContent = editor === null || editor === void 0 ? void 0 : editor.getContent()) !== null && _editor$getContent !== void 0 ? _editor$getContent : "";
      setValue(editor, content);
    }
    function handleDone(name, url) {
      var _editor$getContent2, _content$replace;
      var editor = unref(editorRef);
      if (!editor) {
        return;
      }
      var content = (_editor$getContent2 = editor === null || editor === void 0 ? void 0 : editor.getContent()) !== null && _editor$getContent2 !== void 0 ? _editor$getContent2 : "";
      var val = (_content$replace = content === null || content === void 0 ? void 0 : content.replace(getUploadingImgName(name), "<img src=\"".concat(url, "\"/>"))) !== null && _content$replace !== void 0 ? _content$replace : "";
      setValue(editor, val);
    }
    function getUploadingImgName(name) {
      return "[uploading:".concat(name, "]");
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "prefixCls",
        style: _normalizeStyle({
          width: _unref(containerWidth)
        })
      }, [_createElementVNode("textarea", {
        id: _unref(tinymceId),
        ref_key: "elRef",
        ref: elRef,
        style: {
          visibility: 'hidden'
        }
      }, null, 8, _hoisted_1)], 4);
    };
  }
};